import React, { useEffect, useContext } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import Header from './components/Header.jsx'

import VideoApp from './pages/VideoApp.jsx';

import PgHome from './pages/PgHome.jsx'
import PgLives from './pages/PgLives.jsx'
import PgSignIn from './pages/PgSignIn.jsx'
import PgSignUp from './pages/PgSignUp.jsx'
import PgUsuario from './pages/PgUsuario.jsx'
import PgCanal from './pages/PgCanal.jsx'

import PgaSobre from './pages/auxiliary/PgaSobre.jsx'
import PgaSuporte from './pages/auxiliary/PgaSuporte.jsx'
import PgaTermos from './pages/auxiliary/PgaTermos.jsx'
import PgaPoliticas from './pages/auxiliary/PgaPoliticas.jsx'

import PgaAssinatura from './pages/auxiliary/PgaAssinatura.jsx'
import PgaIngressoTV from './pages/auxiliary/PgaIngressoTV.jsx'
import PgaBilheteria from './pages/auxiliary/PgaBilheteria.jsx'
import PgaIngresso from './pages/PgIngresso.jsx'

import { global } from './api/global'
import { MeuContexto } from "./App.jsx"

import NavRodape from './components/navigation/NavRodape.jsx'
import PgAgenda from './pages/PgAgenda.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';

function Rotas() {
  const { logado, setlogado, gett, setgett } = useContext(MeuContexto)

  useEffect(() => {
    if (!gett) {
      try {
        global.token = localStorage.getItem('@smizetv:token')
      } catch (error) {
        global.token = null
      }

      if (global.token === null) {
        setlogado(false)
      } else {
        setlogado(true)
      }

      setgett(true)
    } else {
      if (logado) {
        try {
          localStorage.setItem('@smizetv:token', global.token);
        } catch (error) {
          // Handle error silently
        }
      }
      
      if (!logado) {
        global.token = null
        try {
          localStorage.removeItem('@smizetv:token');
        } catch (error) {
          // Handle error silently
        }
      }
    }
  }, [logado, setlogado, gett, setgett])

  return (
    <Router
      future={{
        v7_startTransition: true,
      }}
    >
      <div>
        <ScrollToTop />
        <Header />
        
        <Routes>
          <Route path="/" element={<PgHome />} />
          <Route path="/Lives/:Procura" element={<PgLives />} />
          <Route path="/SignIn" element={<PgSignIn />} />
          <Route path="/SignUp" element={<PgSignUp />} />
          <Route path="/Usuario" element={<PgUsuario />} />
          <Route path="/VideoApp" element={<VideoApp />} />
          <Route path="/Canal/:liveId" element={<PgCanal />} />
          <Route path="/Agenda" element={<PgAgenda />} />
          <Route path="/Sobre" element={<PgaSobre />} />
          <Route path="/Suporte" element={<PgaSuporte />} />
          <Route path="/Termos" element={<PgaTermos />} />
          <Route path="/Politicas" element={<PgaPoliticas />} />
          <Route path="/Assinatura" element={<PgaAssinatura />} />
          <Route path="/Ingresso" element={<PgaIngresso />} />
          <Route path="/Bilheteria" element={<PgaBilheteria />} />
          <Route path="/IngressoTV/:liveId" element={<PgaIngressoTV />} />
        </Routes>

        <NavRodape />
      </div>
    </Router>
  );
}

export default Rotas;